// The backend still only ever assigns 'complete', not 'completed'.
// 'processing' means the review has been handed to the bot and is awaiting
// its verdict — the backend literal for this is 'requested', not 'processing'.
export type QueueStatus = 'escalated' | 'completed' | 'processing' | 'canceled';

const API_STATUS_BY_QUEUE_STATUS: Record<QueueStatus, string> = {
  escalated: 'escalated',
  completed: 'complete',
  processing: 'requested',
  canceled: 'canceled',
};

export function toApiStatus(status: QueueStatus): string {
  return API_STATUS_BY_QUEUE_STATUS[status];
}
